import { render, staticRenderFns } from "./single-garbage.vue?vue&type=template&id=fc41e0ec&scoped=true&"
import script from "./single-garbage.vue?vue&type=script&lang=js&"
export * from "./single-garbage.vue?vue&type=script&lang=js&"
import style0 from "./single-garbage.vue?vue&type=style&index=0&id=fc41e0ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc41e0ec",
  null
  
)

export default component.exports